const simpleParallax = require('simple-parallax-js');
const ribbonBlockImages = document.querySelectorAll('.ribbonBlockImage');

window.addEventListener('load', () => {
	new simpleParallax(ribbonBlockImages, {
		delay: .4,
		scale: 1.5
	});
})
